const HttpRequestReducer = (state, action) => {
  switch (action.type) {
    case 'STARTED':
      return {
        ...state,
        status: 'pending',
      };
    case 'RESOLVED':
      return {
        ...state,
        status: 'resolved',
        data: action.data,
      };
    case 'ERROR':
      return {
        ...state,
        status: 'error',
        error: action.error,
      };
    default:
      throw new Error(`Unhandled action type: ${action.type} for HttpRequestReducer`);
  }
};

export default HttpRequestReducer;
